import dynamic from "next/dynamic";

export const TeamMemberCard = dynamic(() => import("./component"));
